import styled from "styled-components";

export const InputGroup = styled.div`
  margin-bottom: 15px;
  text-align: left;
  font-family: gilroy;
  label {
    margin-bottom: 0.5rem;
    display: inline-block;
    color: gray;
    font-size: 19px;
  }
`;
export const InputGroupLoginV2 = styled.div`
  text-align: left;
  font-family: poppins;
  label {
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    font-weight: 400;
    color: #747474;
    display: inline-block;
    font-size: 14px;
  }
`;
